fourToldApp.factory("theme", function($rootScope, $window, esb, favicon, $location){
  
  function loadJSONSync(url) {
    var request = new XMLHttpRequest();
    request.open('GET', url, false);
    request.send(null);
  
    if (request.status === 200) {
      return JSON.parse(request.responseText);
    } else {
      throw new Error('Error loading JSON file: ' + request.statusText);
    }
  }

  return{
    getTheme:function(){
       var activeDiv = document.querySelector('html');
       var data =  JSON.parse($window.sessionStorage.getItem("theme"));
       var theme = null;  
       if (data){
            $rootScope.commerceName =  data.app_name; //nombre del lender
            $rootScope.icon = esb+"/security"+data.small_icon; // icono
            $rootScope.avatar = esb+"/security"+data.lender_avatar; //avatar chat
            favicon.setIcon(esb+"/security"+data.statusbar_icon);
            $rootScope.iconBanner = esb+"/security"+data.lender_avatar; // banner
            $rootScope.title = JSON.parse($window.sessionStorage.getItem("theme")).app_name;
            var header_login_background = undefined;
            header_login_background = data.header_login_background ? data.header_login_background : data.backgroundColor;
            if(data.menu_selected_background && data.menu_selected_textColor){
              var background_selected_menu = document.createElement('style');
              background_selected_menu.type ='text/css';
              background_selected_menu.innerHTML = '.selectedIndex { background: '+data.menu_selected_background+';}';
              document.getElementsByTagName('head')[0].appendChild(background_selected_menu);
          
              var color_selected_menu = document.createElement('style');
              color_selected_menu.type = 'text/css';
              color_selected_menu.innerHTML = '.selectedIndexTextColor { color: '+data.menu_selected_textColor+';}';
              document.getElementsByTagName('head')[0].appendChild(color_selected_menu);
            }
           theme = {
             backgroundColor: {backgroundColor: data.backgroundColor},
             button_Login_background_color: {backgroundColor: data.button_Login_background_color,
             color:data.button_Login_textcolor},
             button_Register_background_color: {backgroundColor: data.button_Register_background_color,
             color: data.button_Register_textcolor},
             text_new_user_login: {color: data.button_Login_background_color},
             button_send:{
               background: data.button_send_background_color,
               color: data.button_send_textcolor,
               'box-shadow': '0 2px 5px 0 rgba(0, 0, 0, 0.26)'
             },
             textColor:{color: data.button_Register_textcolor},
             textColorDescription:{color: data.textColor},
             button_send_chat:{
              color: data.buttonSendChatColor,
            },
             header: {background: data.statusbar_background_color},
             footer: {background: data.footer_background_color},
             bars: {color: data.statusbar_textcolor},
             message_sent_background_color:{background: data.message_sent_background_color, color: data.message_sent_textcolor},
             sent_color:{'border-left': '15px solid' + data.message_sent_background_color},
             message_receive_background_color:{background: data.message_receive_background_color, color: data.message_receive_textcolor},
             receive_color:{'border-right': '15px solid' + data.message_receive_background_color},
             button_selection_chat:{background: data.button_selection_chat_background_color, color: data.button_selection_chat_textcolor},

             drawer_header_background_color: {backgroundColor: data.drawer_header_background_color, color: data.drawer_header_textcolor},
             drawer_body_background_color: {backgroundColor: data.drawer_body_background_color, color: data.drawer_body_textcolor, 'font-weight': '400'},
             drawer_body_textcolor:{color: data.drawer_body_textcolor},
             docTypes: data.login ? data.login.id.types : undefined,
             header_login_background: {background: header_login_background},
             sub_header_background: {background: data.sub_header_background},
             chat_name_textColor: {color: data.chat_name_textColor}
           };
           theme = Object.assign(data, theme);
           theme.getDateFormat = () => theme.date_format || 'dd/MM/yyyy';
           activeDiv.setAttribute('style', 'background-color: white');
       } else{
          activeDiv.removeAttribute('style');
          favicon.setIcon("/images/icons/logo/favicon-32x32.png");
          $rootScope.title = "Borrower Web";
          var background_selected_menu = document.createElement('style');
              background_selected_menu.type ='text/css';
              background_selected_menu.innerHTML = '.selectedIndex { background: #DDDDDD}';
              document.getElementsByTagName('head')[0].appendChild(background_selected_menu);
          
              var color_selected_menu = document.createElement('style');
              color_selected_menu.type = 'text/css';
              color_selected_menu.innerHTML = '.selectedIndexTextColor { color: #19507C}';
              document.getElementsByTagName('head')[0].appendChild(color_selected_menu);
        }
       return theme;
     }
  }
});
fourToldApp.service('actions', function() {
  this.click = function(detailsInfo, expandible, index) {
    if (expandible.isExpandable === "true") {
        expandible.isExpandable = undefined;
        detailsInfo[index] = false;
    } else {
        detailsInfo[index] = true;
        expandible.isExpandable = "true";
    }
  };

  this.closeModal = function(){
    var modal = document.getElementById("imageModal");
    modal.style.display = "none";
  };

});